var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoKroodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 37,
    viewBox: "0 0 178 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2401 30.2054L10.1016 25.0409V36.8603H0.696065V31.4322H4.09311V6.91708H0V1.48901H10.1016V22.2392L15.2401 17.0734V30.2054Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5427 14.7094L20.8135 8.40503H26.9103V13.8343H23.5133L15.6751 21.6278L23.6003 29.4187H27.5194V34.8468H20.8135L14.5427 28.4542V14.7094Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5794 34.8456H29.6101V29.4175H33.0059V13.8343H29.6101V8.40503H38.5794V34.8456Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9703 9.71881H39.3637V14.1848C40.1468 12.6087 41.1933 11.3832 42.5867 10.6821C43.9927 9.88016 45.5832 9.4578 47.2019 9.45654V15.6727C46.3318 15.6727 45.3735 15.8479 44.5891 16.1102C43.7191 16.3737 42.9347 16.8982 42.1504 17.511C41.1933 18.3873 40.5843 19.3506 40.235 20.4009C39.974 21.4512 39.8 22.5886 39.8 23.8154V30.7313H43.1958V36.1606H37.8833L37.9703 9.71881Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4102 33.6212C68.3864 34.4833 67.2419 35.191 66.0132 35.7218C64.3588 36.4228 62.5304 36.8604 60.6137 36.8604C58.6983 36.8604 56.8686 36.5099 55.2142 35.7218C53.5629 35.0193 52.0789 33.9751 50.8601 32.6579C49.6407 31.3453 48.5954 29.9445 47.8993 28.1931C47.2033 26.5288 46.854 24.6904 46.854 22.7651C46.854 20.8384 47.202 18.9988 47.9851 17.3357C48.6824 15.6726 49.7278 14.1848 50.9471 12.871C52.2095 11.5869 53.7208 10.5739 55.3883 9.89406C57.0427 9.19427 58.8723 8.84375 60.7877 8.84375C62.7044 8.84375 64.4458 9.19427 66.1002 9.98231C67.3196 10.5068 68.4519 11.2079 69.4102 11.9959V33.6212ZM60.6137 30.9065C61.6578 30.9065 62.7044 30.7325 63.6615 30.2937C64.6198 29.8562 65.4911 29.3304 66.1872 28.5436C66.9137 27.8069 67.5037 26.9471 67.9299 26.0042C68.3649 25.0409 68.5389 23.9906 68.5389 22.9403C68.5389 21.8888 68.3649 20.8384 67.9299 19.8751C67.4948 18.9118 66.9715 18.0368 66.2742 17.3357C65.5782 16.5489 64.7081 16.0232 63.7485 15.5856C62.7914 15.1481 61.7461 14.9729 60.7007 14.9729C59.6566 14.9729 58.6113 15.1469 57.653 15.5856C56.6959 16.0232 55.8245 16.5489 55.1272 17.2487C54.4012 17.9856 53.8116 18.8454 53.3858 19.7881C52.9508 20.7514 52.7768 21.8017 52.7768 22.8521C52.7768 23.9024 52.9508 24.9527 53.3858 26.0042C53.8209 26.9675 54.3429 27.8426 55.039 28.6306C55.7706 29.3598 56.6263 29.9529 57.5659 30.382C58.436 30.7313 59.4814 30.9065 60.6137 30.9065Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8 10.5068L70.3674 11.8207C71.5868 13.0462 72.5451 14.5341 73.3282 16.1984C74.0243 17.8615 74.3735 19.6999 74.3735 21.5382C74.3735 23.4648 74.0255 25.3044 73.3294 27.0545C72.6321 28.7176 71.5868 30.2067 70.3674 31.5193C69.9393 32.0261 69.4408 32.4689 68.8871 32.8344L68.8 10.5068Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0915 35.7219C87.1761 35.7219 85.3464 35.3714 83.692 34.5846C82.0406 33.8817 80.5566 32.8371 79.3379 31.5194C78.1186 30.2069 77.072 28.8073 76.3759 27.0547C75.6798 25.3916 75.3306 23.552 75.3306 21.6266C75.3306 19.7 75.6786 17.8604 76.4617 16.1986C77.159 14.5342 78.2043 13.0464 79.4237 11.7326C80.6861 10.4484 82.1973 9.43545 83.8648 8.75563C85.5205 8.05584 87.3514 7.70532 89.2655 7.70532C91.1822 7.70532 92.9236 8.05584 94.578 8.84389C96.2076 9.54651 97.686 10.5573 98.9321 11.8208C100.151 13.0464 101.11 14.5342 101.894 16.1986C102.59 17.8617 102.938 19.7 102.938 21.5384C102.938 23.465 102.59 25.3046 101.894 27.0547C101.197 28.7178 100.151 30.2069 98.9321 31.5194C97.714 32.8333 96.2324 33.7966 94.578 34.5846C92.8366 35.3714 91.0069 35.7219 89.0915 35.7219V35.7219ZM89.0915 29.7681C90.1356 29.7681 91.1822 29.5941 92.1393 29.1553C93.0976 28.7178 93.969 28.1933 94.665 27.4052C95.3911 26.6684 95.9807 25.8086 96.4064 24.8658C96.8415 23.9025 97.0155 22.8522 97.0155 21.8019C97.0155 20.7503 96.8415 19.7013 96.4064 18.7367C95.9714 17.7734 95.4493 16.8984 94.7533 16.1986C94.0217 15.4689 93.166 14.8754 92.2263 14.446C91.2692 14.0097 90.2239 13.8344 89.1785 13.8344C88.1344 13.8344 87.0891 14.0084 86.1308 14.4472C85.1737 14.8847 84.3011 15.4105 83.605 16.1103C82.879 16.8471 82.2894 17.7069 81.8636 18.6497C81.4286 19.613 81.2546 20.6633 81.2546 21.7136C81.2546 22.7639 81.4286 23.8143 81.8636 24.8658C82.2987 25.8291 82.8207 26.7054 83.5168 27.4922C84.2484 28.2214 85.1041 28.8145 86.0438 29.2436C86.9138 29.5941 87.9592 29.7681 89.0915 29.7681Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.872 35.4596C115.256 35.3808 113.666 35.0255 112.17 34.4093C110.516 33.7083 109.122 32.6567 107.903 31.4324C106.685 30.2068 105.725 28.7178 105.029 27.0547C104.333 25.3913 103.978 23.605 103.985 21.8019C103.985 19.9623 104.333 18.2121 105.029 16.5478C105.725 14.8847 106.683 13.4839 107.903 12.1701C109.121 10.9445 110.516 9.89417 112.17 9.19438C113.65 8.49334 115.218 8.14282 116.96 8.14282V13.9226C116.351 14.0097 115.741 14.1837 115.131 14.4472C114.174 14.8847 113.302 15.4105 112.606 16.1985C111.88 16.9349 111.29 17.7943 110.864 18.7367C110.429 19.7 110.255 20.7503 110.255 21.8889C110.255 22.9392 110.429 23.9895 110.864 24.9528C111.299 25.9161 111.821 26.7924 112.606 27.4922C113.337 28.2211 114.192 28.8142 115.131 29.2435C115.74 29.5058 116.35 29.6811 116.96 29.7681L116.873 35.4596H116.872Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2323 25.829C96.3193 25.6537 96.4063 25.4785 96.4933 25.215C96.9283 24.2529 97.1024 23.2013 97.1024 22.151C97.1024 21.1007 96.9283 20.0504 96.4933 19.0871C96.413 18.8374 96.2956 18.6011 96.1453 18.3861V10.0693C97.1894 10.6821 98.1489 11.4702 99.019 12.257C100.238 13.4838 101.197 14.9716 101.98 16.636C102.677 18.2991 103.025 20.1374 103.025 21.9758C103.025 23.9024 102.677 25.742 101.981 27.4921C101.284 29.1552 100.238 30.6443 99.019 31.9569C98.1489 32.8331 97.2776 33.5329 96.2323 34.1457V25.829V25.829Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.78 35.3713H138.035V5.42806H134.64V0H141.781L141.78 35.3713Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.104 31.4323C125.191 32.8691 123.894 34.0214 122.36 34.7585C120.879 35.4595 119.224 35.8088 117.482 35.8088C115.654 35.8088 113.911 35.4595 112.257 34.7585C110.602 34.0587 109.209 33.0072 107.99 31.7816C106.77 30.556 105.812 29.0682 105.116 27.4038C104.419 25.7406 104.064 23.9543 104.071 22.151C104.071 20.3127 104.419 18.5613 105.115 16.8982C105.812 15.2351 106.77 13.8343 107.99 12.5205C109.208 11.2949 110.602 10.2446 112.257 9.54355C113.824 8.84376 115.567 8.49324 117.482 8.49324C119.137 8.49324 120.791 8.84375 122.273 9.6318C123.839 10.3316 125.06 11.4702 126.104 12.7827V5.42931H122.708V0H132.113V29.9432H135.509V35.3713H126.104V31.4311V31.4323ZM118.267 30.2055C119.398 30.2055 120.443 30.0315 121.401 29.5927C122.341 29.1638 123.196 28.5712 123.927 27.8426C124.674 27.0889 125.265 26.1962 125.669 25.215C126.104 24.2529 126.278 23.2013 126.278 22.064C126.278 21.0125 126.104 19.9634 125.669 18.9988C125.234 18.0368 124.711 17.1605 123.927 16.4607C123.196 15.7312 122.341 15.1377 121.401 14.7081C120.444 14.2718 119.398 14.0966 118.354 14.0966C117.221 14.0966 116.176 14.2706 115.218 14.7093C114.278 15.1386 113.423 15.7316 112.692 16.4607C111.966 17.1973 111.377 18.0566 110.952 18.9988C110.515 19.9622 110.341 21.0125 110.341 22.151C110.341 23.2013 110.515 24.2517 110.951 25.215C111.386 26.1783 111.908 27.0546 112.692 27.7544C113.423 28.4834 114.278 29.0765 115.218 29.5057C116.089 30.0315 117.134 30.2055 118.267 30.2055V30.2055Z",
    fill: "url(#paint10_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.1453 9.9812C97.1894 10.594 98.1489 11.382 99.019 12.1701C100.238 13.3956 101.197 14.8847 101.98 16.5478C102.677 18.2109 103.025 20.0493 103.025 21.8889C103.025 23.8155 102.677 25.6526 101.981 27.404C101.284 29.0683 100.238 30.5561 99.019 31.87C98.1489 32.745 97.2776 33.4448 96.2323 34.0576V25.7421C96.3193 25.5668 96.4063 25.3046 96.4933 25.1293C96.9283 24.166 97.1024 23.1157 97.1024 22.0654C97.1024 21.0138 96.9283 19.9635 96.4933 19.0002C96.4128 18.7509 96.2955 18.515 96.1453 18.3004V9.9812V9.9812Z",
    fill: "#EC006E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.96 35.7219C115.344 35.6431 113.753 35.2879 112.257 34.6715C110.602 33.9705 109.209 32.919 107.99 31.6946C106.77 30.4691 105.812 28.98 105.116 27.3169C104.419 25.6536 104.064 23.8673 104.071 22.0641C104.071 20.2245 104.419 18.4744 105.115 16.81C105.812 15.1469 106.77 13.7461 107.99 12.4323C109.208 11.2067 110.602 10.1564 112.257 9.45534C113.737 8.75555 115.305 8.40503 117.047 8.40503V14.1849C116.438 14.2719 115.828 14.4459 115.218 14.7094C114.279 15.1382 113.423 15.7309 112.692 16.4595C111.966 17.1964 111.377 18.0562 110.952 18.9989C110.515 19.9622 110.341 21.0125 110.341 22.1511C110.341 23.2014 110.515 24.2517 110.951 25.215C111.386 26.1783 111.908 27.0546 112.692 27.7544C113.423 28.4835 114.278 29.0765 115.218 29.5057C115.827 29.768 116.437 29.9433 117.047 30.0303L116.96 35.7219Z",
    fill: "#EC006E"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.035 36.51V6.56674H134.639V1.13867H144.044V31.0819H148.138V36.51H138.035Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.455 1.13745H132.113V31.0807H135.509V36.51H128.455V1.13745Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.282 30.1186C156.934 29.9433 156.586 29.6811 156.237 29.4175C155.541 28.893 155.017 28.2802 154.495 27.4909C154.147 26.9664 153.886 26.3536 153.624 25.6526H157.369V20.488H153.537C153.711 19.787 154.059 19.0872 154.494 18.3874C154.929 17.6864 155.539 17.0736 156.15 16.5478C156.498 16.2855 156.933 16.022 157.281 15.7598V9.80591C156.759 9.98117 156.237 10.1564 155.715 10.4187C154.059 11.1197 152.666 12.1713 151.446 13.3956C150.228 14.6212 149.27 16.1103 148.573 17.7734C147.876 19.4675 147.521 21.2827 147.528 23.1144C147.528 25.041 147.876 26.7911 148.573 28.4555C149.24 30.0601 150.216 31.5176 151.446 32.745C152.666 33.9706 154.146 34.9326 155.802 35.6337C156.237 35.8089 156.759 35.9842 157.194 36.1594L157.281 30.1186H157.282Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.258 30.4653H178V35.8971H172.258V30.4653Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.062 34.9338C157.717 35.6336 159.459 35.8971 161.288 35.8971H166.949V30.4691H161.113C160.243 30.4691 159.373 30.2938 158.502 30.0303C157.687 29.7442 156.922 29.3306 156.237 28.8047C156.15 28.7177 156.063 28.7177 155.976 28.6307L156.063 34.9326L156.062 34.9338ZM155.975 16.022L156.149 15.848C156.846 15.3222 157.543 14.8847 158.326 14.6212C159.111 14.2719 159.982 14.1836 160.765 14.1836C162.682 14.1836 164.336 14.7094 165.729 15.7597C167.122 16.81 168.081 18.1239 168.603 19.874H156.062V25.0398H174.351L174.525 22.4134C174.525 20.575 174.264 18.8237 173.655 17.2476C173.046 15.5845 172.174 14.0966 170.868 12.7828C169.647 11.4702 168.081 10.5069 166.426 9.72013C164.772 9.01785 162.943 8.58032 161.113 8.58032C159.286 8.58032 157.543 8.93084 156.063 9.54363L155.975 16.022Z",
    fill: "url(#paint15_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.59414,
    y1: 88.941,
    x2: 7.59414,
    y2: -0.410424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 21.0427,
    y1: 61.7037,
    x2: 21.0427,
    y2: 12.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0086CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 34.1064,
    y1: 70.3896,
    x2: 34.1064,
    y2: 5.29562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0086CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 42.605,
    y1: 88.0866,
    x2: 42.605,
    y2: -5.06778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C288E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 58.1141,
    y1: 88.0832,
    x2: 58.1141,
    y2: -5.0665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C288E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 83.4461,
    y1: 77.0741,
    x2: 47.9502,
    y2: 67.6636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC006E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 101.135,
    y1: 72.8692,
    x2: 82.7782,
    y2: -2.96483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC006E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 122.593,
    y1: 67.7727,
    x2: 75.355,
    y2: 22.4268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC006E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 99.6134,
    y1: 64.352,
    x2: 99.6134,
    y2: -5.63329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC006E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 138.256,
    y1: 71.1104,
    x2: 138.256,
    y2: -9.99947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC006E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 119.765,
    y1: 71.1092,
    x2: 119.765,
    y2: -9.99782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC006E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 99.0159,
    y1: 51.7798,
    x2: 160.756,
    y2: 44.7943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#556AB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 95.4768,
    y1: 47.1748,
    x2: 154.277,
    y2: 45.3581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#556AB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 106.613,
    y1: 61.6644,
    x2: 168.206,
    y2: 54.9924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#556AB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 175.095,
    y1: 118.998,
    x2: 175.095,
    y2: 4.90495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 165.255,
    y1: 118.948,
    x2: 165.255,
    y2: 4.9226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKroodle);
export default __webpack_public_path__ + "static/media/logo-kroodle.8d5aae814f95da2a295463b841c78174.svg";
export { ForwardRef as ReactComponent };